/**
 * Résultat des edge functions de création de compte (`create-driver-account`,
 * `create-tenant`).
 *
 * Quand l'e-mail avait DÉJÀ un compte confirmé, la fonction ne touche pas à son
 * mot de passe : elle répond `temp_password: null` et `compte_existant: true`.
 * Il ne faut alors jamais afficher « null » : on dit à la personne comment se
 * connecter.
 */
import { corpsContact, resumeAcces, type ContactValide } from './commun'

export const MESSAGE_COMPTE_EXISTANT_FONCTION =
  'Ce compte existait déjà : la personne se connecte avec son mot de passe habituel ou « Continuer avec Google ».'

export function aMotDePasseTemporaire(
  r: { temp_password?: string | null | undefined } | null | undefined,
): r is { temp_password: string } {
  return typeof r?.temp_password === 'string' && r.temp_password.length > 0
}

/* ------------------------------------------------------------------ e-mail OU numéro WhatsApp */

/** Réponse commune de `create-driver-account` / `create-tenant` (avec un numéro seul : pas de mot de passe temporaire). */
export interface AccesCree {
  email: string | null
  /** E.164 (« +22370123456 »). */
  phone: string | null
  temp_password: string | null
  compte_existant?: boolean
  connexion?: 'mot_de_passe' | 'whatsapp' | 'existant'
}

/** Corps de `create-driver-account` : `phone` en E.164 + `pays` ; `email` seulement s'il est saisi. */
export function corpsCompteLivreur(
  orgId: string,
  d: { first_name: string; last_name: string; contact: ContactValide },
): Record<string, unknown> {
  return { org_id: orgId, first_name: d.first_name.trim(), last_name: d.last_name.trim(), ...corpsContact(d.contact) }
}

/** Corps de `invite-member` : le contact (e-mail et/ou numéro), le rôle, les droits et l'intitulé. */
export function corpsInvitation(
  orgId: string,
  m: { contact: ContactValide; role: string; permissions?: Record<string, boolean> | undefined; title?: string | null | undefined },
): Record<string, unknown> {
  return { org_id: orgId, ...corpsContact(m.contact), role: m.role, permissions: m.permissions ?? {}, title: m.title ?? null }
}

/** Phrase affichée à la place du mot de passe quand il n'y en a pas : numéro seul, ou compte déjà existant. */
export function phraseSansMotDePasse(r: AccesCree): string {
  if (r.connexion === 'whatsapp' || (!r.email && r.phone)) return resumeAcces(r).phrase
  return MESSAGE_COMPTE_EXISTANT_FONCTION
}
